import Vue from 'vue'
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'
// import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import { isDefine } from '@/utils/validatevform.js'
VXETable.setup({
  size: 'small',
  table: {
    stripe: true,
    border: true,
    resizable: true,
    showOverflow: true,
    align: 'center',
    editConfig: {
      enabled: true,
      trigger: 'click', // 设置触发编辑为手动模式
      mode: 'cell', // 设置为整行编辑模式
      showStatus: false
    },
    keepSource: true,
    emptyText: '暂无数据',
    exportConfig: {
      filename: '',
      sheetName: 'Sheet1',
      // 默认选中类型
      type: 'csv',
      // 自定义类型
      types: ['csv', 'html', 'xml', 'txt'],
      mode: 'current',
      isMerge: true,
      isColgroup: false,
      // columnFilterMethod({ column, $columnIndex }) {
      //   console.log('123',$columnIndex);
      //   return !['checkbox'].includes(column.type)
      // }
    },
    treeConfig: {
      children: 'children'
    },
    sortConfig: {
      remote: true,
      trigger: 'default',
      orders: ['asc', 'desc', null],
      sortMethod: null
    }
  },
  grid: {
    pagerConfig: {
      pageSizes: [10, 20, 50, 100, 500, 1000],
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]
    }
  }
})
// 限制只能输入数字
const validateNumber = (value) => {
  const signStr = value.charAt(0)
  value = value
    .replace('.', '$#$') // 把第一个字符'.'替换成'$#$'
    .replace(/\./g, '') // 把其余的字符'.'替换为空
    .replace('$#$', '.') // 把字符S#S替换回原来的'.'
    .replace(/[^\d.]/g, '') // 只能输入数字和'.'
    .replace(/^\./g, '') // 不能以.开头
    .replace(/([0-9]+\.[0-9]{6})[0-9]*/, '$1') // 只保留6位小数
  if (signStr === '-') value = '-' + value
  return value
}
// 限制只能输入正整数和0
const vPositiveInteger = (val) => {
  //只能输入数字
  val = val.replace(/\D/g, '')

  //第一位输入0，第二位输入大于0的数字时候自动清空第一位的0
  if (val > 0) {
    //01 = > 1
    if (val[0] === '0') {
      val = val.substr(1)
    }
  } else if (Number(val) === 0) {
    // 00 => 0
    val = val.slice(0, 1)
  }
  return val
}
// 事件拦截
VXETable.interceptor.add('event.clearActived', (params, event) => {
  // 比如点击了某个组件的弹出层面板之后，此时被激活单元格不应该被自动关闭，通过返回 false 可以阻止默认的行为。
  // element-ui，el-select  el-autocomplete
  // console.log('params--------->', params)
  // console.log('params.$event--------->', params.$event)
  // console.log('params.$event.target--------->', params.$event.target)
  // console.log('params.$event.target.className--------->', params.$event.target.className)
  // console.log(params)
  // console.log(event);
  const targetClassName = params.$event.target.className
  const parentTargetClassName = params.$event.target.parentElement.className
  if (
    targetClassName.indexOf('el-select-dropdown__item') > -1 ||
    parentTargetClassName.indexOf('el-select-dropdown__item') > -1
  ) {
    return false
  }
  if (
    targetClassName.indexOf('el-autocomplete') > -1 ||
    parentTargetClassName.indexOf('el-autocomplete') > -1
  ) {
    return false
  }
})

VXETable.renderer.add('el-input2', {
  // 表头单元格显示内容 - 输入框渲染
  renderHeader(h, renderOpts, params) {
    const { data, property } = params
    const props = renderOpts.props || {}
    return [<vxe-input v-model={data[property]} {...{ props }}></vxe-input>]
  }
})
// 表格内编辑时输入框 - 从服务端搜索数据
VXETable.renderer.add('$el-autocomplete', {
  // 可编辑激活模板
  renderEdit(h, renderOpts, params) {
    const { row, column } = params
    const { attrs = {}, events = {}, fetchSuggestions } = renderOpts
    const newAttrs = {
      ...{ placeholder: '请输入内容', debounce: 500, triggerOnFocus: false },
      ...attrs
    }
    let autocompleteList = []
    return [
      <el-autocomplete
        style="width:100%"
        v-model={row[column.property]}
        {...{ attrs: newAttrs }}
        fetch-suggestions={(queryString, cb) => {
          if (fetchSuggestions) {
            const params = {
              ...fetchSuggestions.params,
              [fetchSuggestions.searchKey]: queryString
            }
            fetchSuggestions
              .methods(params)
              .then((res) => {
                let suggestionsData = res.data
                if (fetchSuggestions.handleData) {
                  suggestionsData = fetchSuggestions.handleData(res)
                }
                autocompleteList = suggestionsData
                if (res.data.length > 0) {
                  cb(autocompleteList)
                } else {
                  setTimeout(() => cb(autocompleteList), 500)
                  VXETable.modal.message({ status: 'warning', content: '暂无相关数据！' })
                }
              })
              .catch(() => (this.isDisable = false))
          } else {
            cb([])
            VXETable.modal.message({ status: 'warning', content: '暂无相关数据！' })
          }
        }}
        onSelect={(item) => {
          events.select && events.select(item, row, params)
        }}
        onChange={(val) => {
          const { valueKey = 'value' } = newAttrs
          const result = autocompleteList.find((item) => item[valueKey] === val)
          if (!result) row[column.property] = ''
        }}
      />
    ]
  },
  // 可编辑显示模板
  renderCell(h, renderOpts, { row, column }) {
    return [<span>{row[column.property]}</span>]
  }
})
// 表格内编辑时输入框
VXETable.renderer.add('$el-input', {
  // 可编辑激活模板
  renderEdit(h, renderOpts, params) {
    const { row, column } = params
    const { attrs = {}, events = {}, value = '', type } = renderOpts
    const newAttrs = { ...{ placeholder: '请输入' }, ...attrs }
    if (!isDefine(row[column.property])) {
      row[column.property] = value
    }
    return [
      <el-input
        {...{ attrs: newAttrs }}
        v-model={row[column.property]}
        onInput={(value) => {
          if (type === 'number') {
            // const signStr = value.charAt(0)
            // value = value
            //   .replace('.', '$#$') // 把第一个字符'.'替换成'$#$'
            //   .replace(/\./g, '') // 把其余的字符'.'替换为空
            //   .replace('$#$', '.') // 把字符S#S替换回原来的'.'
            //   .replace(/[^\d.]/g, '') // 只能输入数字和'.'
            //   .replace(/^\./g, '') // 不能以.开头
            //   .replace(/([0-9]+\.[0-9]{6})[0-9]*/, '$1') // 只保留6位小数
            // if (signStr === '-') value = '-' + value
            row[column.property] = validateNumber(value)
          }
          if (type === 'positiveInteger') {
            value = value.replace(/^(0+)|[^\d]+/g, '')
            row[column.property] = value
          }
          events.input && events.input(params, row[column.property], row)
        }}
        onBlur={() => {
          events.blur && events.blur(row[column.property], row)
        }}
        // 键盘按下事件，通过键码 keyCode 判断是否为回车
        nativeOnKeyup={(e) =>
          e.keyCode === 13 && events.keyupEnter && events.keyupEnter(row[column.property], row)
        }
      />
    ]
  },
  // 可编辑显示模板
  renderCell(h, renderOpts, { row, column }) {
    const { value = '' } = renderOpts
    if (!isDefine(row[column.property])) {
      row[column.property] = value
    }
    return [<span>{row[column.property]}</span>]
  }
})
// import EditDownTable from './components/EditDownTable.vue'
// Vue.component(EditDownTable.name, EditDownTable)
// // 创建一个下拉表格渲染
// VXETable.renderer.add('EditDownTable', {
//   autofocus: '.vxe-input--inner',
//   renderEdit(h, renderOpts, params) {
//     return [<edit-down-table params={params}></edit-down-table>]
//   }
// })
// 表格内编辑时下拉框
VXETable.renderer.add('$el-select', {
  // 可编辑激活模板
  renderEdit(h, renderOpts, params) {
    const { row, column } = params
    let { options = [] } = renderOpts
    const {
      rowOptionKey,
      value = '',
      attrs = { placeholder: '请选择' },
      events = {},
      size = "mini",
      labelKey = 'text',
      labelVal = 'value',
      disabled = []
    } = renderOpts
    if (rowOptionKey) options = row[rowOptionKey] || []
    if (!isDefine(row[column.property])) {
      row[column.property] = value
    }
    return [
      <el-select
        {...{ attrs }}
        v-model={row[column.property]}
        size={size}
        disabled={disabled}
        popper-append-to-body={true}
        onChange={(data) => {
          row[column.property] = data
          events.change &&
            events.change({
              params,
              value: data,
              row,
              selectedData: options.find((item) => item[labelVal] === row[column.property])
            })
        }}
      >
        {options.map((item) => {
          return (
            <el-option
              label={item[labelKey]}
              value={item[labelVal]}
            />
          )
        })}
      </el-select>
    ]
  },
  // 可编辑显示模板
  renderCell(h, renderOpts, { row, column }) {
    const { options = [], value = '', labelKey = 'label', labelVal = 'value' } = renderOpts
    if (!isDefine(row[column.property])) {
      row[column.property] = value
    }
    let showData = row[column.property]
    if (showData && options.length > 0) {
      // ;({ [labelKey]: showData } = options.find((item) => item[labelVal] === String(showData)))
      const result = options.find((item) => item[labelVal] === String(showData))
      if (result) showData = result[labelKey]
    }
    return [<span>{showData}</span>]
  }
})
// 表格内编辑时日期输入框
VXETable.renderer.add('$el-date-picker', {
  // 可编辑激活模板
  renderEdit(h, renderOpts, params) {
    const { row, column } = params
    let defaultSet = { valueFormat: 'yyyy-MM-dd', placeholder: '请选择' }
    const { attrs = {}, events = {} } = renderOpts
    // 合并配置项，只合并key少的属性
    Object.keys(defaultSet).forEach((key) => {
      if (!attrs.hasOwnProperty.call(key)) attrs[key] = defaultSet[key]
    })

    return [
      <el-date-picker
        {...{ attrs }}
        v-model={row[column.property]}
        append-to-body={true}
        onChange={(data) => {
          row[column.property] = data
          events.change && events.change({ params, value: data, row })
        }}
      />
    ]
  },
  // 可编辑显示模板
  renderCell(h, renderOpts, { row, column }) {
    return [<span>{row[column.property]}</span>]
  }
})

VXETable.renderer.add('el-input', {
  // 表头单元格`VNode渲染`输入框
  renderHeader(h, renderOpts, params) {
    const { events = {}, type } = renderOpts
    console.log(params)
    return [
      h('el-input', {
        props: renderOpts.attrs || {},
        attrs: renderOpts.attrs || {},
        model: {
          value: renderOpts.value || '',
          callback: function callback($$v) {
            Vue.set(renderOpts, 'value', $$v)
          }
        },
        on: {
          input: function (value) {
            if (type === 'number') {
              // const signStr = value.charAt(0)
              // value = value
              //   .replace('.', '$#$') // 把第一个字符'.'替换成'$#$'
              //   .replace(/\./g, '') // 把其余的字符'.'替换为空
              //   .replace('$#$', '.') // 把字符S#S替换回原来的'.'
              //   .replace(/[^\d.]/g, '') // 只能输入数字和'.'
              //   .replace(/^\./g, '') // 不能以.开头
              //   .replace(/([0-9]+\.[0-9]{6})[0-9]*/, '$1') // 只保留6位小数
              // if (signStr === '-') value = '-' + value
              renderOpts.value = validateNumber(value)
            }
            if (type === 'positiveInteger') {
              value = value.replace(/^(0+)|[^\d]+/g, '')
              renderOpts.value = value
            }
            events.input && events.input(value)
          },
          change: function (val) {
            events.change && events.change(val)
          }
        }
      })
    ]
    // input 标签，可以使用批量绑定属性； return <input {...{ attrs: inputAttrs }} />
  }
})
VXETable.renderer.add('interval-input', {
  // 表头单元格`VNode渲染`区间范围输入框
  renderHeader(h, renderOpts, params) {
    console.log(params)
    const { value = { startVal: '', endVal: '' }, events = {}, type } = renderOpts
    return [
      <el-row style="display:flex;align-items:center">
        <el-col span={11}>
          <el-input
            placeholder="下限"
            value={value.startVal}
            onInput={(val) => {
              if (type === 'positiveInteger') {
                renderOpts.value.startVal = vPositiveInteger(val)
              } else {
                renderOpts.value.startVal = validateNumber(val)
              }
              // renderOpts.value.startVal = val.replace(/^\.+|[^\d.]/g, '')
              events.input && events.input(renderOpts.value)
            }}
          />
        </el-col>
        <el-col span={2}>-</el-col>
        <el-col span={11}>
          <el-input
            placeholder="上限"
            value={value.endVal}
            onInput={(val) => {
              if (type === 'positiveInteger') {
                renderOpts.value.endVal = vPositiveInteger(val)
              } else {
                renderOpts.value.endVal = validateNumber(val)
              }
              events.input && events.input(renderOpts.value)
            }}
          />
        </el-col>
      </el-row>
    ]
  }
})
VXETable.renderer.add('el-select', {
  // 表头单元格`JSX 渲染`下拉框
  renderHeader(h, renderOpts, params) {
    console.log(params)
    const {
      options = [],
      value = '',
      attrs = { placeholder: '请选择' },
      events = {},
      labelKey = 'label',
      labelVal = 'value'
    } = renderOpts

    return [
      <el-select
        style="width: 100%"
        {...{ attrs }}
        // vModel={value}
        value={value}
        onChange={(data) => {
          renderOpts.value = data
          events.change &&
            events.change(
              data,
              options.find((item) => item[labelVal] === value)
            )
        }}
      >
        {options.map((item) => {
          return <el-option label={item[labelKey]} value={item[labelVal]} />
        })}
      </el-select>
    ]
  },
  // 单元格显示默认内容`JSX 渲染`下拉框
  renderDefault(h, renderOpts, { row, column }) {
    const {
      options = [],
      value = '',
      attrs = { placeholder: '请选择' },
      events = {},
      labelKey = 'label',
      labelVal = 'value'
    } = renderOpts
    return [
      <el-select
        {...{ attrs }}
        v-model={row[column.property]}
        onChange={(data) => {
          row[column.property] = data
          events.change &&
            events.change(
              data,
              options.find((item) => item[labelVal] === value)
            )
        }}
      >
        {options.map((item) => {
          return <el-option label={item[labelKey]} value={item[labelVal]} />
        })}
      </el-select>
    ]
    // return [<input class="my-cell" text="text" v-model={row[column.property]} />]
  }
})
VXETable.renderer.add('el-date-picker', {
  // 表头单元格`JSX 渲染`下拉框
  renderHeader(h, renderOpts) {
    const { value = '', events = {} } = renderOpts

    return [
      <el-date-picker
        value={value}
        onInput={(data) => {
          renderOpts.value = data
          events.change(data)
        }}
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        append-to-body={true}
      />
    ]
  }
})
VXETable.renderer.add('el-cascader', {
  // 表头单元格`JSX 渲染`级联选择器
  renderHeader(h, renderOpts) {
    const { options = [], value = [], attrs = { placeholder: '请选择' }, events = {} } = renderOpts
    return [
      <el-cascader
        class="w100"
        {...{ attrs }}
        value={value}
        options={options}
        onChange={(data) => {
          renderOpts.value = data
          events.change && events.change(data)
        }}
      />
    ]
  }
})
VXETable.renderer.add('vxe-input', {
  // 表头单元格输入框 - JSX 渲染
  renderHeader(h, renderOpts, params) {
    console.log(params)
    const { events = {} } = renderOpts
    const props = renderOpts.attrs || {}
    return [
      <vxe-input
        v-model={renderOpts.value}
        {...{ props }}
        onInput={({ value }) => events.input(value)}
      />
    ]
  }
})

VXETable.renderer.add('customToolBtns', {
  // 工具栏 按钮渲染器
  renderButton(h, renderOpts, params) {
    console.log(params)
    const { events = {} } = renderOpts
    const { toolbarBtnName = [] } = renderOpts.attr
    return [
      <div class="fixed-button-group">
        {toolbarBtnName.map((item) => {
          const type = {}[item] || '' //按钮类型
          const plain = ![].includes(item) //按钮plain
          return (
            <el-button
              size="medium"
              plain={plain}
              type={type}
              onClick={() => {
                events.click(item)
              }}
            >
              {item}
            </el-button>
          )
        })}
      </div>
    ]
  }
})

Vue.use(VXETable)
Vue.use(XEUtils)
// VXETable.use(VXETablePluginExportXLSX)
VXETable.use(VXETablePluginElement)
Vue.prototype.$XModal = VXETable.modal
Vue.prototype.XEUtils = XEUtils
